var map = {
	"./01_maska_mazok_1.svg": 669,
	"./02_maska_krug_1.svg": 670,
	"./03_maska_krug_2.svg": 671,
	"./04_maska_mazok_2.svg": 672,
	"./05_maska_pyatno_1.svg": 673,
	"./06_maska_romb_1.svg": 674,
	"./07_maska_pyatno_2.svg": 675,
	"./08_maska_mazok_3.svg": 676,
	"./09_maska_4-kvadrata.svg": 677,
	"./10_maska_setka-vypuklaya.svg": 678,
	"./11_maska_5-ugol.svg": 679,
	"./12_maska_shit.svg": 680,
	"./13_maska_kniga.svg": 681,
	"./14_maska_shesterenka.svg": 682,
	"./15_maska_klever.svg": 683,
	"./16_maska_klen.svg": 684,
	"./17_maska_kot.svg": 685,
	"./18_maska_serdce.svg": 686,
	"./19_maska_vog-kvadrat.svg": 687,
	"./20_maska_kvadrat-ten.svg": 688,
	"./21_maska_kvadrat-shtrih.svg": 689,
	"./22_maska_kvadrat-skruglenny.svg": 690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1496;